// i18n
import { TFunction } from 'i18next'

export const getErrorMessage = (errorCode: string, t: TFunction): string => {
  const translation = t(`errors.${errorCode}`, { defaultValue: '' })

  if (translation && translation !== `errors.${errorCode}`) {
    return translation
  }

  return t('errors.UNEXPECTED_ERROR')
}
